var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 66,
    viewBox: "0 0 74 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9007 56.3577L61.5 52.957",
    stroke: "#D31C4F",
    strokeWidth: 2.17224,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5862 64.0413L69.1855 60.6406",
    stroke: "#D31C4F",
    strokeWidth: 2.17224,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9007 60.6406L61.5 64.0413",
    stroke: "#D31C4F",
    strokeWidth: 2.17224,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5862 52.957L69.1855 56.3577",
    stroke: "#D31C4F",
    strokeWidth: 2.17224,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37432 5.33136L2 1.95703",
    stroke: "#D31C4F",
    strokeWidth: 2.15541,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 12.9564L9.625 9.58203",
    stroke: "#D31C4F",
    strokeWidth: 2.15541,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37432 9.58203L2 12.9564",
    stroke: "#D31C4F",
    strokeWidth: 2.15541,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 1.95703L9.625 5.33136",
    stroke: "#D31C4F",
    strokeWidth: 2.15541,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6193 48.6484C41.0909 48.7582 41.1371 49.3837 40.6797 49.5425C40.5083 49.602 40.334 49.6611 40.1567 49.7202L36.4701 50.9335C27.2067 53.9202 22.3301 51.4235 19.3201 42.1602L16.3334 32.9435C13.3467 23.6802 15.8201 18.7802 25.0834 15.7935L27.6607 14.94C28.0636 14.8066 28.4458 15.2068 28.3109 15.6091C28.0208 16.4743 27.7595 17.4224 27.5101 18.4535L25.2234 28.2302C22.6567 39.2202 26.4134 45.2868 37.4034 47.9002L40.6193 48.6484Z",
    fill: "#D31C4F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5633 9.44624L46.6667 8.53624C38.8733 6.6929 34.23 8.20957 31.5 13.8562C30.8 15.2796 30.24 17.0062 29.7733 18.9896L27.4867 28.7662C25.2 38.5196 28.21 43.3262 37.94 45.6362L41.86 46.5696C43.2133 46.8962 44.4733 47.1062 45.64 47.1996C52.92 47.8996 56.7933 44.4929 58.7533 36.0696L61.04 26.3162C63.3267 16.5629 60.34 11.7329 50.5633 9.44624ZM46.1767 33.0596C45.9667 33.8529 45.2667 34.3662 44.4733 34.3662C44.3333 34.3662 44.1933 34.3429 44.03 34.3196L37.24 32.5929C36.3067 32.3596 35.7467 31.4029 35.98 30.4696C36.2133 29.5362 37.17 28.9762 38.1033 29.2096L44.8933 30.9362C45.85 31.1696 46.41 32.1262 46.1767 33.0596ZM53.0133 25.1729C52.8033 25.9662 52.1033 26.4796 51.31 26.4796C51.17 26.4796 51.03 26.4562 50.8667 26.4329L39.55 23.5629C38.6167 23.3296 38.0567 22.3729 38.29 21.4396C38.5233 20.5062 39.48 19.9462 40.4133 20.1796L51.73 23.0496C52.6867 23.2596 53.2467 24.2162 53.0133 25.1729Z",
    fill: "#D31C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogButton);
export default __webpack_public_path__ + "static/media/blogButton.d86bbfce57d492e499fc2214207ab4f8.svg";
export { ForwardRef as ReactComponent };